import {SportstypeSpec} from "../types";
import start from "../../icons/tennis/start";
import end from "../../icons/tennis/end";
import setWin from "../../icons/tennis/set-win";
import main from "../../icons/tennis/main";
import { ISetBasedScoreboard } from "@webng-types/write-model";
import { addToScore, isHomeTeam, makeUpdateSetBasedScoreboardScoreModification } from "../eventHandlerUtils";

const tennis: SportstypeSpec = {
  id: 'tennis',
  scoreboardType: 'set-based-scoreboard',
  isFastSportstype: true,
  svg: main,
  releaseStage: 'released',
  phases: ['pregame', {id: 'set', max: 5}, 'tie-break', 'postgame'],
  events: [
    {
      id: 'start',
      important: false,
      svg: start
    },
    {
      id: 'end',
      important: false,
      svg: end
    },
    {
      id: "game-win",
      important: true,
      svg: setWin,
      team: "any",
      eventHandler: (game, event, isNewEvent) => {
        if(isNewEvent && game.state_info && game.scoreboard && event.sport_event && event.sport_event.team) {
          const currentSet = game.state_info.recurrence ?? 0
          let scores = (game.scoreboard as ISetBasedScoreboard).scores ?? []

          const isHome = isHomeTeam(game, event)

          if(scores.length <= currentSet) scores = Array.from({...scores, length: currentSet+1}, (score) => score ?? {
            _type: "Tik::Model::Content::Scoreboard::ScoreboardScore",
            away_score: "",
            home_score: "",
          })

          scores[currentSet] = addToScore(scores[currentSet], 1, isHome, 0)

          return [makeUpdateSetBasedScoreboardScoreModification(scores)]
        } else return []
      }
    },
/*    {
      id: 'set-win',
      important: true,
      svg: setWin,
      team: "any",
    } */
  ],
  legacyEventMap: {
    1: "end",
    2: "start",
    100: "game-win",
  }
}

export default tennis
